// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'
import {SeqId} from './seq-id.js'

export class UpdateCheckbox {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): UpdateCheckbox {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsUpdateCheckbox(bb: flatbuffers.ByteBuffer, obj?: UpdateCheckbox): UpdateCheckbox {
    return (obj || new UpdateCheckbox()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsUpdateCheckbox(bb: flatbuffers.ByteBuffer, obj?: UpdateCheckbox): UpdateCheckbox {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new UpdateCheckbox()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  textField(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  location(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  isChecked(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false
  }

  static startUpdateCheckbox(builder: flatbuffers.Builder) {
    builder.startObject(3)
  }

  static addTextField(builder: flatbuffers.Builder, textFieldOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, textFieldOffset, 0)
  }

  static addLocation(builder: flatbuffers.Builder, locationOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, locationOffset, 0)
  }

  static addIsChecked(builder: flatbuffers.Builder, isChecked: boolean) {
    builder.addFieldInt8(2, +isChecked, +false)
  }

  static endUpdateCheckbox(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }
}
